import React, { useState } from 'react';
import { motion } from 'framer-motion';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [status, setStatus] = useState('');

  const locations = [
    {
      name: 'Chadstone',
      address: 'Level 2, 1341 Dandenong Rd, Chadstone VIC 3148',
      phone: '(03) 8723 0159',
      isHeadOffice: true,
    },
    {
      name: 'Collins Street',
      address: 'Level 2, 260 Collins Street, Melbourne VIC 3000',
      phone: '(03) 8723 0159',
      isHeadOffice: false,
    },
    {
      name: 'Sunshine',
      address: 'Level 4/301 Hampshire Rd, Sunshine VIC 3020',
      phone: '(03) 8723 0159',
      isHeadOffice: false,
    },
    {
      name: 'Mickleham',
      address: 'Level 3/21 Cityside Drive, Mickleham VIC 3064',
      phone: '(03) 8723 0159',
      isHeadOffice: false,
    }
  ];

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');

    try {
      const response = await fetch('https://formspree.io/f/xdalngqo', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          message: formData.message,
          _replyto: formData.email,
          _subject: `New Contact from ${formData.name} - Vesta Designs Website`,
        }),
      });

      if (response.ok) {
        setStatus('success');
        setFormData({ name: '', email: '', message: '' });
        setTimeout(() => setStatus(''), 5000);
      } else {
        const mailtoLink = `mailto:director@vestadesigns.com.au?subject=New Contact from ${encodeURIComponent(formData.name)}&body=${encodeURIComponent(`Name: ${formData.name}\nEmail: ${formData.email}\n\nMessage:\n${formData.message}`)}`;
        window.location.href = mailtoLink;
        setStatus('');
      }
    } catch (error) {
      const mailtoLink = `mailto:director@vestadesigns.com.au?subject=New Contact from ${encodeURIComponent(formData.name)}&body=${encodeURIComponent(`Name: ${formData.name}\nEmail: ${formData.email}\n\nMessage:\n${formData.message}`)}`;
      window.location.href = mailtoLink;
      setStatus('');
    }
  };

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="contact-hero-simple">
        <div className="container">
          <motion.h1 
            className="contact-hero-title"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Contact Us
          </motion.h1>
        </div>
      </section>

      {/* Locations Section - First */}
      <section className="contact-locations-section">
        <div className="container">
          <div className="contact-locations-grid">
            {locations.map((location, index) => (
              <motion.div 
                key={index}
                className={`contact-location-card ${location.isHeadOffice ? 'head-office' : ''}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
              >
                {location.isHeadOffice && <span className="head-office-badge">Head Office</span>}
                <h3 className="location-name">{location.name}</h3>
                <div className="location-details">
                  <div className="location-item">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                      <circle cx="12" cy="10" r="3"/>
                    </svg>
                    <span>{location.address}</span>
                  </div>
                  <div className="location-item">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                    </svg>
                    <a href={`tel:${location.phone.replace(/\s/g, '')}`}>{location.phone}</a>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Form and Map Split Section */}
      <section className="contact-split-section">
        {/* Left - Form */}
        <motion.div 
          className="contact-split-form"
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <div className="contact-form-content">
            <h2 className="contact-form-title">Ready To Work Together?</h2>
            <p className="contact-form-subtitle">Get in touch and let's create something extraordinary together.</p>
            <form className="contact-form-modern" onSubmit={handleSubmit}>
              <div className="form-field">
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Name*"
                  required
                />
              </div>
              <div className="form-field">
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email address*"
                  required
                />
              </div>
              <div className="form-field">
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Your message"
                  rows="4"
                ></textarea>
              </div>
              <button type="submit" className="btn-send-message" disabled={status === 'sending'}>
                {status === 'sending' ? 'Sending...' : 'Send message'}
              </button>
              {status === 'success' && (
                <p className="form-status success">Message sent successfully!</p>
              )}
              {status === 'error' && (
                <p className="form-status error">Failed to send. Please try again.</p>
              )}
            </form>
          </div>
        </motion.div>

        {/* Right - Map */}
        <div className="contact-split-map">
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3149.547896548!2d145.0834!3d-37.8864!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad66b4c9e7e2b1d%3A0x5045675218ce840!2sChadstone%20Shopping%20Centre!5e0!3m2!1sen!2sau!4v1625687467855!5m2!1sen!2sau" 
            width="100%" 
            height="100%" 
            style={{ border: 0 }} 
            allowFullScreen="" 
            loading="lazy"
            title="Vesta Designs Head Office - Chadstone"
          ></iframe>
        </div>
      </section>
    </div>
  );
};

export default Contact;
